import styled from 'styled-components';

import { gridSizes, weights } from 'utils/style';

import Header from 'components/RecurringOrderSuggestionsModal/Sections/Header/component';

export default styled(Header)`
  & {
    text-align: center;
  }

  .title {
    font-size: 20px;
    font-weight: ${weights('medium')};
    line-height: 26px;
    color: var(--grey900);
    margin: ${gridSizes('L')} 0;
  }

  .subtitle {
    font-size: 16px;
    font-weight: ${weights('normal')};
    line-height: 21px;
    color: var(--grey700);
    margin-bottom: ${gridSizes('L')};
  }

  hr {
    border-bottom: 1px solid var(--grey300);
    margin: 0 40px;
    border-top: none;
  }
`;

// & {
//   border-bottom: 1px solid var(--grey300);
// }
